import { FC } from 'react';
import { SbRespContentModuleCreator_browseContentModule$data } from './__generated__/SbRespContentModuleCreator_browseContentModule.graphql';

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SbRespContentModuleBase } from './../SbRespContentModuleBase/SbRespContentModuleBase';
import { SbSharedStorefrontCreatorLink } from '../SbSharedStorefrontLink/SbSharedStorefrontCreatorLink';

type Props = {
    browseContentModule: SbRespContentModuleCreator_browseContentModule$data;
    className?: string;
};

const SbRespContentModuleCreatorComponent: FC<Props> = ({ browseContentModule, className }) => {
    const { description, title } = browseContentModule;

    if (!description && !title) {
        return null;
    }

    return (
        <SbRespContentModuleBase
            title={title}
            description={description}
            photo={null}
            className={className}
        >
            <SbSharedStorefrontCreatorLink browseContentModule={browseContentModule} />
        </SbRespContentModuleBase>
    );
};

export const SbRespContentModuleCreator = createFragmentContainer(
    SbRespContentModuleCreatorComponent,
    {
        browseContentModule: graphql`
            fragment SbRespContentModuleCreator_browseContentModule on ContentModuleCreator {
                ...SbSharedStorefrontCreatorLink_browseContentModule
                description
                title
            }
        `,
    }
);
